import { InjectionToken } from '@angular/core';

/** Runtime VM emitted by `CartTipPickerBlock` data sources. */
export type CartTipPickerBlockViewModel = {
  tipsAllowed: boolean;
  totalAmount: number;
  selectedTip: number;
};

export const CART_TIP_PICKER_BLOCK_LOADING_VM: CartTipPickerBlockViewModel = {
  tipsAllowed: false,
  totalAmount: 0,
  selectedTip: 0,
};

export interface CartTipPickerBlockDataSource {
  readonly vm$: import('rxjs').Observable<CartTipPickerBlockViewModel>;
}

export const CART_TIP_PICKER_BLOCK_DATA_SOURCE = new InjectionToken<CartTipPickerBlockDataSource>(
  'CART_TIP_PICKER_BLOCK_DATA_SOURCE',
);
